export interface Route {
    title: string;
    query: string;
}

export const routes: Record<string, Route> = {
    '/': {
        title: 'Introduction',
        query: `{
    aboutMe {
        sectionTitle
        profilePictureUrl
        introductionHtml
    }
}`,
    },
    '/experience': {
        title: 'Experience',
        query: `{
    experience {
        sectionTitle
        history {
            company {
                label
                url
            }
            period {
                start
                end
            }
            description
        }
    }
}
`,
    },
    '/contact': {
        title: 'Contact',
        query: `{
    contactInformation {
        sectionTitle
        introductionHtml
        links {
            label
            url
        }
    }
}`,
    },
};
